import { createFileRoute } from "@tanstack/react-router";
import TmsForFirefighters from "@/pages/TmsForFirefighters";
export const Route = createFileRoute("/tms-for-firefighters")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS For Firefighters | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS for firefighters facing depression and PTSD. Learn about first responder mental health treatment at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "TMS For Firefighters | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS for firefighters facing depression and PTSD. Learn about first responder mental health treatment at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-for-firefighters",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-for-firefighters",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsForFirefighters />;
}
